import { saveSupplier, updateSupplier } from 'actions/Catalogs';
import Loader from 'components/UI/Loader';
import React, { useEffect, useState } from 'react'
import { IoCloseCircleOutline } from "react-icons/io5";
import { notify } from 'utils';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

const ModalHeader = ({ title, onClose }) => (
  <div className='h-20 w-full flex flex-row justify-between items-center px-5 bg-black rounded-t-lg'>
    <span className="text-white font-[Gravity] text-2xl font-bold">
      {title}
    </span>
    <IoCloseCircleOutline onClick={onClose} className='text-white text-4xl cursor-pointer' />
  </div>
)

const ModalSuppliers = ({ isOpen, onClose, selected, getData }) => {
  const [t] = useTranslation('catalog');
  const [showModal, setShowModal] = useState(false);
  const [form, setForm] = useState({
    name: '',
    companyName: '',
  });
  const [status, setStatus] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const { currentProject } = useSelector((state) => state.auth);

  useEffect(() => {
    if (isOpen) {
      setTimeout(() => setShowModal(true), 10);
    } else {
      setShowModal(false);
    }
  }, [isOpen]);

  const validations = () => {
    if (form.name.trim() === '') {
      notify("error", t("suppliers.validation_name"), 1200);
      return false;
    }

    if (form.companyName.trim() === '') {
      notify("error", t("suppliers.validation_company"), 1200);
      return false;
    }

    if (form.name.length < 5) {
      notify("error", t("suppliers.validation_name_length"), 1200);
      return false;
    }

    if (form.companyName.length < 5) {
      notify("error", t("suppliers.validation_company_length"), 1200);
      return false;
    }

    return true;
  }

  const saveResponse = async () => {
    if (!validations()) return;
    setIsLoading(true);

    try {
      let payload = {
        name: form.name,
        companyName: form.companyName,
      };
      if (selected) {
        payload.status = +status === 1 ? true : false;
        await updateSupplier(payload, selected.id);
      } else {
        payload.idProject = currentProject.id;
        await saveSupplier(payload);
      }
      getData(currentProject.id);
      onClose();
    } catch (error) {
      console.error("Error al guardar la pregunta:", error);
      notify("error", t("suppliers.error_save"), 2000);
    } finally {
      setIsLoading(false);
    }
  };


  useEffect(() => {
    if (isOpen && selected) {
      const { name = '', status = true, nameCompany = '' } = selected;
      setForm({
        name: name,
        companyName: nameCompany,
      });
      setStatus(status === true ? 1 : 0)
    }
  }, [isOpen, selected]);

  useEffect(() => {
    if (!isOpen) {
      setForm({
        name: '',
        companyName: '',
      });
      setStatus(0);
    }
  }, [isOpen]);

  if (isLoading) {
    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <Loader />
      </div>
    );
  }

  if (!isOpen) return null;
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className={`bg-white max-h-[90vh] overflow-y-auto rounded-xl shadow-lg w-[90vw] max-w-3xl relative transition-all duration-300 transform ${showModal ? 'scale-100 opacity-100' : 'scale-95 opacity-0'}`}>
        <ModalHeader title={t('suppliers.save_modal_title')} onClose={onClose} />

        <div className='w-full h-[85%] p-5 flex flex-col'>
          <label className='text-black font-bold py-2'>{t('suppliers.name')}:</label>
          <input maxLength={100} className='h-10 w-full bg-gray-300 rounded-lg p-2' value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />

          <label className='text-black font-bold py-2'>{t('suppliers.companyName')}:</label>
          <input maxLength={250} className='h-10 w-full bg-gray-300 rounded-lg p-2' value={form.companyName} onChange={(e) => setForm({ ...form, companyName: e.target.value })} />

          {
            selected && (
              <>
                <label className='text-black font-bold py-2'>{t('suppliers.status')}:</label>
                <select className='border-2 border-gray-400 h-9 rounded-lg' value={status} onChange={({ target }) => setStatus(target.value)}>
                  <option value={1}>Activo</option>
                  <option value={0}>Inactivo</option>
                </select>
              </>
            )
          }

          <div className='w-full mt-auto flex justify-end gap-2 pt-4'>
            <div className='h-10 w-32 flex items-center justify-center text-white rounded-lg bg-black cursor-pointer hover:shadow-md hover:bg-[#EBC533]' onClick={onClose}>{t('suppliers.cancel')}</div>
            <div className='h-10 w-32 flex items-center justify-center text-white rounded-lg bg-black cursor-pointer hover:shadow-md hover:bg-[#EBC533]' onClick={saveResponse}>{t('suppliers.save')}</div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ModalSuppliers